module.exports = __webpack_public_path__ + "static/3-415af12430bd4559fc6a005547da0e67.png";